const locale = 'tr-TR';

export const formatMoney = (value, options = {}) => new Intl.NumberFormat(locale, {
  style: 'currency',
  currency: 'TRY',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  ...options,
}).format(Number(value || 0));

export const formatNumber = (value) => Number(value || 0).toLocaleString(locale);

export const formatDateTime = (value, fallback = '-') => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' });
};

export const transactionStatusLabel = {
  beklemede: 'Beklemede',
  onaylandi: 'Onaylandı',
  reddedildi: 'Reddedildi',
};

export const transactionTypeLabel = {
  deposit: 'Yatırım',
  withdraw: 'Çekim',
  bonus: 'Bonus',
  bet: 'Bahis',
};

